import React from 'react';

import { Tab } from '@lux/tabs';

import { Category } from '../types';
import * as S from './styles';
import { Chip } from './chip';

interface CategoryTabsProps {
    categories: Category[];
    onTabChange: (params: { index: number; value: string }) => void;
}

export const CategoryTabs: React.FC<CategoryTabsProps> = ({ categories, onTabChange }) => {
    return (
        <S.TabListWrapper>
            <S.StyledTabList aria-labelledby="continue-shopping-title" onChange={onTabChange}>
                {categories.map(category => (
                    <Tab key={category.category_id} asChild for={category.category_id.toString()}>
                        <Chip>{category.category_name}</Chip>
                    </Tab>
                ))}
            </S.StyledTabList>
        </S.TabListWrapper>
    );
};
